import { useState } from "react";
import { ProgramaCard } from "./ProgramaCard";
import { paginacion } from "../../utils/paginacion/paginacion";
import { DataTable } from "../../components/organisms/DataTable";

const PROGRAMAS_POR_PAGINA = 15;

export const ProgramaList = ({ programas = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: programasEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, programas, PROGRAMAS_POR_PAGINA);

  const columnas = ["#", "Nombre", "Duración", "Costo", "Opciones"];

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {programasEnPagina.map((programa, index) => (
        <ProgramaCard
          key={programa?.idPrograma || index}
          programa={programa}
          index={(paginaActual - 1) * PROGRAMAS_POR_PAGINA + index + 1} // ← Conteo global
          onDelete={onDelete}
        />
      ))}
    </DataTable>
  );
};
